import createReducer from "./reducerUtils";
import {
  LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_VALIDAR,
  LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_CONFIRMAR,
  LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_VALIDAR,
  LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_CONFIRMAR,
  LOADING_TRANSFERENCIA_CUENTAS_IFIS_VALIDAR,
  LOADING_TRANSFERENCIA_CUENTAS_IFIS_CONFIRMAR,
  LOAD_BANCOS_TRANSFERENCIA,
  LOADING_BANCOS_TRANSFERENCIA,
} from "../actions/actionTypes";

const initialState = {
  loadingTransferenciaCuentasPropiasValidar: false,
  loadingTransferenciaCuentasPropiasConfirmar: false,
  loadingTransferenciaCuentasPrymeraValidar: false,
  loadingTransferenciaCuentasPrymeraConfirmar: false,
  loadingTransferenciaCuentasIfisValidar: false,
  loadingTransferenciaCuentasIfisConfirmar: false,
  bancosTransferencia: [],
  loadingBancosTransferencias: false,
};

const loadingTransferenciaCuentasPropiasValidar = (state, payload) => {
  return {
    ...state,
    loadingTransferenciaCuentasPropiasValidar: payload.loading,
  };
};

const loadingTransferenciaCuentasPropiasConfirmar = (state, payload) => {
  return {
    ...state,
    loadingTransferenciaCuentasPropiasConfirmar: payload.loading,
  };
};

const loadingTransferenciaCuentasPrymeraValidar = (state, payload) => {
  return {
    ...state,
    loadingTransferenciaCuentasPrymeraValidar: payload.loading,
  };
};

const loadingTransferenciaCuentasPrymeraConfirmar = (state, payload) => {
  return {
    ...state,
    loadingTransferenciaCuentasPrymeraConfirmar: payload.loading,
  };
};

const loadingTransferenciaCuentasIfisValidar = (state, payload) => {
  return {
    ...state,
    loadingTransferenciaCuentasIfisValidar: payload.loading,
  };
};

const loadingTransferenciaCuentasIfisConfirmar = (state, payload) => {
  return {
    ...state,
    loadingTransferenciaCuentasIfisConfirmar: payload.loading,
  };
};

const loadBancosTransferencias = (state, payload) => {
  return {
    ...state,
    bancosTransferencia: payload.bancosTransferencia,
  };
};

const loadingBancosTransferencias = (state, payload) => {
  return {
    ...state,
    loadingBancosTransferencias: payload.loading,
  };
};

export default createReducer(initialState, {
  [LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_VALIDAR]: loadingTransferenciaCuentasPropiasValidar,
  [LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_CONFIRMAR]: loadingTransferenciaCuentasPropiasConfirmar,
  [LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_VALIDAR]: loadingTransferenciaCuentasPrymeraValidar,
  [LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_CONFIRMAR]: loadingTransferenciaCuentasPrymeraConfirmar,
  [LOADING_TRANSFERENCIA_CUENTAS_IFIS_VALIDAR]: loadingTransferenciaCuentasIfisValidar,
  [LOADING_TRANSFERENCIA_CUENTAS_IFIS_CONFIRMAR]: loadingTransferenciaCuentasIfisConfirmar,
  [LOAD_BANCOS_TRANSFERENCIA]: loadBancosTransferencias,
  [LOADING_BANCOS_TRANSFERENCIA]: loadingBancosTransferencias,
});
